import { useMutation } from '@tanstack/react-query';
import useToast from '../useToast';
import {
  startContentCreatorApplicationPost,
  TStartContentCreatorApplicationBody,
} from '@/services/api/requests/contentCreatorApplications';
import { TCustomAxiosError } from '@/services/api';

const useStartContentCreatorApplication = (onSuccessCallback?: (data: TStartContentCreatorApplicationBody) => void) => {
  const toast = useToast();

  const { isPending, mutate } = useMutation({
    mutationFn: async ({ data, turnstileToken }: { data: TStartContentCreatorApplicationBody; turnstileToken: string }) => {
      await startContentCreatorApplicationPost(data, turnstileToken);
      return data;
    },
    onSuccess: (data) => {
      onSuccessCallback?.(data);
    },
    onError: (error: TCustomAxiosError) => {
      toast({
        status: 'error',
        title: 'Error',
        description: error?.errors?.[0]?.message || 'An error occurred while starting your application.',
      });
    },
  });

  return { isPending, mutate };
};

export default useStartContentCreatorApplication;
